import {
  Box,
  IconButton,
  TextField,
  makeStyles,
} from "@material-ui/core";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { NumericFormat } from "react-number-format";
import { customtheme } from "../../../app/theme/theme";
import { useState } from "react";

const useStyles = makeStyles((theme) => ({
  container: {
    position: "relative",
    display: "flex",
    flex: 1,
    "&:hover $buttonContainer": {
      opacity: 1,
    },
  },
  textField: {
    minWidth: 140,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    "& .MuiInputBase-input": {
      color: customtheme.black,
      textAlign: "right",
      paddingRight: 24,
    },
    "& .MuiInput-underline:hover:before": {
      borderBottomColor: customtheme.blue[500],
    },
  },
  buttonContainer: {
    position: "absolute",
    right: 0,
    bottom: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    height: 24,
    width: 16,
    opacity: 0,
    transition: "opacity 0.2s ease-in-out",
  },
  spinButton: {
    padding: 0,
    flex: 1,
    height: "50%",
    width: 16,
    minWidth: "auto",
    color: customtheme.blue[500],
    borderRadius: 0,
    "&:hover": {
      backgroundColor: customtheme.blue[50],
    },
    "&:disabled": {
      color: theme.palette.action.disabled,
    },
  },
  icon: {
    fontSize: "0.65rem",
  },
}));

interface Props {
  label: string;
  value: number | null;
  onChange: (value: number | null) => void;
  step?: number;
  min?: number;
}

const NumberInputWithSpinner = ({
  label,
  value,
  onChange,
  step = 0.01,
  min = 0,
}: Props) => {
  const classes = useStyles();
  const [hover, setHover] = useState(false);

  const increment = () => {
    const base = value ?? min;
    onChange(Number((base + step).toFixed(2)));
  };

  const decrement = () => {
    const base = value ?? min;
    onChange(Number(Math.max(min, base - step).toFixed(2)));
  };

  return (
    <Box
      className={classes.container}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <NumericFormat
        value={value}
        customInput={TextField}
        label={label}
        thousandSeparator="."
        decimalSeparator=","
        decimalScale={2}
        fixedDecimalScale
        allowNegative={false}
        onValueChange={(v) => onChange(v.floatValue ?? null)}
        className={classes.textField}
        fullWidth
      />

      <Box
        className={classes.buttonContainer}
        style={{ opacity: hover ? 1 : 0 }}
      >
        <IconButton
          size="small"
          className={classes.spinButton}
          onClick={increment}
          tabIndex={-1}
        >
          <ExpandLessIcon className={classes.icon} />
        </IconButton>

        <IconButton
          size="small"
          className={classes.spinButton}
          onClick={decrement}
          disabled={(value ?? 0) <= min}
          tabIndex={-1}
        >
          <ExpandMoreIcon className={classes.icon} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default NumberInputWithSpinner;